import { normalizePoint, pointInPolygon } from './zoneGeometry';

export const sortZonesForRender = (zones = []) => {
  return [...zones].sort((a, b) => {
    const areaA = Number(a?.area) || 0;
    const areaB = Number(b?.area) || 0;
    if (areaA !== areaB) return areaB - areaA; // largest first, smallest last (smallest renders on top)
    const depthA = Number(a?.depth) || 0;
    const depthB = Number(b?.depth) || 0;
    return depthA - depthB;
  });
};

export const pickSmallestContainingZone = (zones = [], latlng = null) => {
  return pickContainingZones(zones, latlng)[0] || null;
};

export const pickContainingZones = (zones = [], latlng = null) => {
  const point = normalizePoint(latlng);
  if (!point) return [];
  const candidates = zones
    .filter((z) => Array.isArray(z?._points) && z._points.length >= 3)
    .filter((z) => pointInPolygon(point, z._points));
  if (!candidates.length) return [];
  return candidates.sort((a, b) => {
    const areaA = Number(a?.area) || 0;
    const areaB = Number(b?.area) || 0;
    if (areaA !== areaB) return areaA - areaB; // smallest area wins
    const depthA = Number(a?.depth) || 0;
    const depthB = Number(b?.depth) || 0;
    return depthA - depthB;
  });
};
